import { motion } from "framer-motion";
import { Reveal, SectionHeader, Corners } from "./Bits";

const SOLDIERS_IMG =
  "https://images.unsplash.com/photo-1569242840510-9fe6f0112cee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwZ2VhcnxlbnwwfHx8fDE3ODY5OTQ5MDJ8MA&ixlib=rb-4.1.0&q=85";

const WEAPONS = [
  { name: "VX-9 SPECTRE", type: "SUPPRESSED SIDEARM", stats: { RANGE: 42, NOISE: 8, LETHALITY: 55 } },
  { name: "RD-4 LONGWHISPER", type: "INTEGRALLY SUPPRESSED DMR", stats: { RANGE: 91, NOISE: 14, LETHALITY: 88 } },
  { name: "EMP CHARGE MK.II", type: "AREA DENIAL // NON-LETHAL", stats: { RANGE: 30, NOISE: 22, LETHALITY: 10 } },
];

const StatBar = ({ label, value, delay }) => (
  <div className="flex items-center gap-4">
    <span className="w-24 font-mono text-[10px] tracking-[0.25em] text-slate-500">{label}</span>
    <div className="h-1.5 flex-1 bg-line">
      <motion.div
        initial={{ width: 0 }}
        whileInView={{ width: `${value}%` }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
        className="h-full bg-signal"
      />
    </div>
    <span className="w-8 text-right font-mono text-[10px] text-signal">{value}</span>
  </div>
);

export const Arsenal = () => (
  <section
    id="arsenal"
    data-testid="arsenal-section"
    className="border-y border-line bg-void px-6 py-28 md:px-12 md:py-36"
  >
    <div className="mx-auto max-w-[1400px]">
      <SectionHeader
        index="02"
        label="ARSENAL"
        title="Quiet Instruments"
        desc="Issued equipment. Field-tested under blackout conditions. If you hear it working, it has already failed."
      />
      <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="relative">
            <div
              className="absolute -inset-8 opacity-60"
              style={{
                background:
                  "radial-gradient(ellipse at 50% 0%, rgba(0,217,255,0.12), transparent 60%)",
              }}
            />
            <div className="clip-angle relative overflow-hidden border border-line">
              <img
                src={SOLDIERS_IMG}
                alt="Operatives in night-vision gear awaiting deployment"
                className="h-[420px] w-full object-cover contrast-125 brightness-[0.6] saturate-0"
              />
              <div className="absolute inset-0 bg-signal/10 mix-blend-overlay" />
              <div className="grid-bg absolute inset-0 opacity-20" />
              <Corners />
            </div>
            <p className="mt-4 font-mono text-[10px] tracking-[0.3em] text-slate-600">
              FIG 02 — NIGHT REHEARSAL // UNIT 7 // <span className="redacted">LOCATION SEALED</span>
            </p>
          </div>
        </Reveal>
        <div className="space-y-10">
          {WEAPONS.map((w, i) => (
            <Reveal key={w.name} delay={i * 0.1}>
              <div
                data-testid={`weapon-row-${i}`}
                className="group border-b border-line pb-8"
              >
                <div className="flex items-baseline justify-between gap-4">
                  <h3 className="font-mono text-lg font-bold uppercase tracking-wide text-[#F8FAFC] transition-colors group-hover:text-signal md:text-xl">
                    {w.name}
                  </h3>
                  <span className="font-mono text-[10px] tracking-[0.25em] text-slate-500">
                    {w.type}
                  </span>
                </div>
                <div className="mt-5 space-y-3">
                  {Object.entries(w.stats).map(([label, value], j) => (
                    <StatBar key={label} label={label} value={value} delay={0.1 + j * 0.08} />
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <p className="font-mono text-[10px] tracking-[0.3em] text-slate-600">
              NOISE RATING MEASURED AT 5M // LOWER IS SURVIVABLE
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
